import React from 'react'
import LeaveApproval from '../Components/LeaveManagement/LeaveApproval/LeaveApproval'

const LeaveApprovalPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
        <LeaveApproval/>
      
    </div>
  )
}

export default LeaveApprovalPage
